import { FOCUSABLE_ELEMENTS_SELECTOR } from "../../../../shared/utility/constants";
import { getHTMLElement } from "../../../../shared/utility/helper";

export function getAllFocusableElements(
  element: Element | null,
): HTMLElement[] {
  const htmlElements: HTMLElement[] = [];

  element?.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR).forEach((element) => {
    const htmlElement = getHTMLElement(element);

    if (htmlElement !== null) {
      htmlElements.push(htmlElement);
    }
  });

  return htmlElements;
}
